import * as api from '../api';
import {
    load as loadGames,
    add as addNewGame
} from '../store/gamesReducer';
import {
    load as loadGameToEdit
} from '../store/gameReducer';
import {
    load as loadPlayers,
    add as addNewPlayer,
    update as updateExistingPlayer
} from '../store/playersReducer';
import {
    loading,
    loaded,
    offline
} from '../store/uiReducer';
import {
    update as updateNotifications
} from '../store/notificationsReducer';



//begin utility methods

const prepareReasons = (list) => {
    let arr = [];
    list.forEach(function (value) {
        arr.push({
            R: value
        });
    });
    return arr;
}

const prepareStatements = (list) => {
    let arr = [];
    list.forEach(function (value) {
        arr.push({
            S: value
        });
    });
    return arr;
}

const preparePlayer = (playerForm) => {
    return {
        name: playerForm.name,
        image: playerForm.image,
        gameId: playerForm.gameId,
        details: {
            Name: playerForm.name,
            HR: prepareReasons(playerForm.HR),
            SR: prepareReasons(playerForm.SR),
            HS: prepareStatements(playerForm.HS),
            SS: prepareStatements(playerForm.SS)

        }
    }
}

//end utility methods


export const loadGame = (id, games) => (dispatch) => {
    const game = games.find(x => x.id === id)
    dispatch(loadGameToEdit(game));
}


export const getGames = () => (dispatch) => {
            dispatch(loading());
            return api.fetchAllGames().then((response) => {
                dispatch(loadGames(response));
                dispatch(loaded());
            }).catch((error) => {
                // games are retrieved on the very first page,
                console.log(error);
            })
        

}

export const getMyGames = () => (dispatch, getState) => {
    dispatch(loading());
    // clear games in the reducer so don't see any that are not theirs
    // must be done every time, as otherwise can elevate permissions by returning to home page
    const token = getState().firebase.auth.stsTokenManager.accessToken;
    return api.getMyGames(token).then((response) => {
        dispatch(loadGames(response));
        dispatch(loaded());
    }).catch((error) => {
        console.log(error);
    });
}




export const receivePlayers = (id) => (dispatch) => {
    dispatch(loadPlayers([]));
    dispatch(loading());
    return  api.getPlayers(id).then((players) => {
                dispatch(loadPlayers(players));
                dispatch(loaded());
            }).catch((error) => {
                console.log(error);
            });
        
}



export const getCurrentPlayers = (id) => (dispatch) => {
    dispatch(loading());    
    return api.getPlayers(id).then((players) => {
        dispatch(loadPlayers(players));
        dispatch(loaded());
    }).catch((error) => {
        dispatch(offline());
    });
}


export const addPlayer = (playerForm) => (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
        const token = getState().firebase.auth.stsTokenManager.accessToken;
        //convert playerForm into player object expected on server
        const player = preparePlayer(playerForm);
        //  console.log(player);
        api.addPlayer(player, token).then((response) => {
            dispatch(addNewPlayer(player));
            dispatch(updateNotifications(player.gameId));
            return api.getPlayers(player.gameId);
        }).then((players) => {
            dispatch(loadPlayers(players));
            resolve(players);
        }).catch(error => {
            reject(error);
        })
    })
}


export const updatePlayer = (playerForm) => (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
        const token = getState().firebase.auth.stsTokenManager.accessToken;
        //convert playerForm into player object expected on server
        const player = preparePlayer(playerForm);
        player.id = playerForm.id;
        api.updatePlayer(player, token).then((response) => {
           // player.game_id = player.gameId;
            dispatch(updateNotifications(player.gameId));
            dispatch(updateExistingPlayer(player));
            resolve(response);
        }).catch(error => {
            reject(error);
        })
    });
}


export const deletePlayer = (player) => (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
        const token = getState().firebase.auth.stsTokenManager.accessToken;
        api.deletePlayer(token, player.gameId, player.id).then((response) => {
            dispatch(loadGames([]));
            resolve(player);
        }).catch(error => {
            reject(error);
        })
    });
}



export const addGame = (game) => (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
        const token = getState().firebase.auth.stsTokenManager.accessToken;
        api.addGame(game, token).then((response) => {
            game.id = response.toString();
            dispatch(updateNotifications(game.id));
            dispatch(addNewGame(game));
            resolve(response);
        }).catch(error => {
            reject(error);
        })
    })
}

export const updateGame = (game) => (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
        const token = getState().firebase.auth.stsTokenManager.accessToken;
        api.updateGame(game, token).then((response) => {
            dispatch(updateNotifications(game.id));
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

export const deleteGame = (game) => (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
        const token = getState().firebase.auth.stsTokenManager.accessToken;
        api.deleteGame(token, game.id).then((response) => {
            dispatch(loadGames([]));
            resolve(game);
        }).catch(error => {
            reject(error);
        })
    });
}

export const getFixedPlayers = () => (dispatch) => {

    const p = [{
            image: "data:image/jpeg;base64,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",
            details: {
                Name: "Cartman",
                HR: [{
                    R: "Cartman frees South Park of hippies by driving a drilling machine through a festival crowd and then playing Death Metal at the audience."
                }, {
                    R: "Cartman gets revenge on Scott Tenorman by killing his parents and feeding them to him in a chili"
                }, {
                    R: "Cartman gets to make Kyle watch as he plays with a toy dump truck - his reward for freeing South Park of hippies"
                }, {
                    R: "Cartman is very happy to become a poster boy for NAMBLA - sadly, not the North American Marlon Brando Look-alike Association"
                }, {
                    R: "Cartman inherits enough money to buy an amusement park - and keeps Stan and Kyle out"
                }, {
                    R: "Cartman is invited to Casa Bonita for Kyles birthday bash"
                }, {
                    R: "Cartman befriends the dark god Cthulu and rains vengeance down on his 'friends'"
                }, {
                    R: "Cartman pretends to be a robot, befriends Butters and gets him to admit to wetting the bed..."
                }],
                SR: [{
                    R: "Cartman is busted for locking Butters in a bomb shelter so he can take his place on a trip to Casa Bonita"
                }, {
                    R: "Cartman buries himself in snow planning to hibernate until the WII comes out - and ends up trapped in the 25th century"
                }, {
                    R: "Cartman is sent to tolerance camp after calling Kyle 'a covetous jew'"
                }, {
                    R: "Cartman loses a fight with Wendy Testaburger and is utterly humiliated"
                }, {
                    R: "Cartman is humiliated when Scott Tenorman tricks him into buying his shaved pubes"
                }, {
                    R: "Cartman discovers that his mother is a crack whore.  Hilarity ensues."
                }, {
                    R: "Cartman is brought under control by the dog whisper, starts to do well in school and behaves himself.  Yeuch!"
                }, {
                    R: "Cartman sees the funniest thing ever - butt heads whose heads look like butts - and worries that he will never laugh again"
                }, {
                    R: "Cartman is furious when his old friends take against his new friend, Michael Jackson.  And just because they like to sleep in the same bed..."
                }],
                "HS": [{
                    S: "Suck My B***s!"
                }, {
                    S: "Screw you guys, I'm goin' home"
                }, {
                    S: "Was it worth it?  Totally!"
                }, {
                    S: "Was it worth it?  Totally!"
                }, {
                    S: "Respect my authorita!"
                }, {
                    S: "Yeah!  I want Cheesy Poofs"
                }, {
                    S: "Die Hippie.  Die."
                }, {
                    S: "Awesome!"
                }],
                SS: [{
                    S: "I hate gingers!"
                }, {
                    S: "There are too many minorities at my waterpark!"
                }, {
                    S: "Mom.  I'm hungry mom."
                }, {
                    S: "I'm not fat.  I'm big-boned."
                }, {
                    S: "I hate you, Kyle"
                }, {
                    S: "Suck My B***s!"
                }, {
                    S: "I swore I would never go to San Francisco"
                }, {
                    S: "Hippies.  They pretend to be nice, but they're evil..."
                }, {
                    S: "Not cool, you  guys!"
                }, {
                    S: "I hate you guys!"
                }]
            },
            name: "Cartman",
            id: 5668600916475904
        },
        {
            image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAyCAYAAADfuMIdAAAFo0lEQVRYR+2YXWwUVRTH//O5nf1iu0hLgQotoCCUNqE1RkXUEHxQio3EBCUxoWgsISa++aAvCgnigx8PRhQeQEENJtCgCRENDxqV1BLUIAItUGwJ2aUf2x26O99mdrelM3OHmR03xETu0+7cc8/53f+599w7QxmGYeA/2qg7cAEzc0e5gMLhtiinqRkMDyRQs7C8vRcMztCQuji/JEga8dqjqIqudQiUyx5FNtUFQELNwnTZAgaDK4VJ9c+zBAwnX0e0+mWk+1fDQP9U36zGv0FR1O2Dk/P9GB3qAIUR30H52GYkat70bR9IObtivqOVDON13agKr/QcVjbcvwELjW+FEj4InR2CARq1C4dvCegbTtfzuH5pkedsCwYGAyALUGGrvUFBGNsJ88CMtz3v6csXnHn8pi/Wl5zJoNRGsPlHoEQPOgLw2S1g1MVFRmoc+cQOi40wuhMAZdYwRNs2VUY508t47xegDK3k0ECu+jVr4JG3zbiOpvKnoES+LD43DAhju4o/QSHe+pwroC/lzNFSug/ywMkpR3JkPzT+TOE/J24CqzR5pkmOHITG/wZhZBdAFQsynZiPyKKHiWN9w2V/PWBxkKt+FYAGYfQDTyi7gRz5BPyNF6cex1rJ688X3I2+H6GPDVhiKPwJcPJjZYMRB/BRxFasd3T5grOrVhkiqxeSehWDM3TV3IMAbZaRm00DDUZXHM/tEwwEJ6XOQ77S4yoWU7MUQn2zpV80d3W0DpF7V097bkDsLe1YgjcmuQDhxocsPZ7KZU4dAq3LRLhQwypwybmOPil9GaFZC4hjTHBi48KINXeUBzd+ch8ohnX603VE29xqFA1AJzLkr/RCTV9w9hkGYrai7KmcG5yw5AkwkWpLkJ6eXrS0tIDjuALctm2vYMeO7ZgxI+5IO4ncvu484cS/TsAQrzp8RVduLNR4Ups4+y3CS52Xz0lbYmqDpFUZTyF//riDQbjvSTBCzH1dmWdnqzkBZyPBsXXNEOYuL2/NmdbEOuey5qYHppKLEWmw3tuyp4+A0vIO4kClxBWu5D7S3AGKDUE8fRjQJKJSkyqLPQfI9Y6wGUxHnmvONFLGriLfd4JcAirwlJ3dBGHeCocnX3AF9Xo+AwK8pHixm3fFuMu9zjec6UTsdV4uvYJ79bvdSHyndTKAdO0s5MFT7vFMZad9tBoez2NmvMrVnk02QGh80LXft3KTHn7p6cYySrylIBzPF/oVmXzsmX0DKoXlD7jfgstWbvfpn3Hs+hAW6xLeSHolzL3/I5HFTyoDQ9dxZO2zlVGu47uvLI7ejcuYSfv//pEHhZfGiqpOts8fXY8q1jzunM13Wu1g011tCCloF8gHvWl3XKLxaY4McCv1KgLnmDNNA7o7rN3+8JoNwZX75tI57On/w/8iKxNuXe18bG5qc/j3pZwlpbZyQST2AaenRkDXJBEzr/dsFfY9/nQwuBe+P4T3EipGNKD73BB+qCPfcqe8e8Cxho73Q1nEwjdrYMUO/u1pFee5iHuaPeBWqyI677JtED6G2Ip2i0/PtKq5DHJnvp4aJOYkbJWsN1tnPqwnBWkW+xNmgb5ZhtiaJRDutl6vPOFMx9PvczIobLHVKntwPZ8DXSV4bqC91Qo4TQWdXIDIolXB1pw5ShWHQfNh0LyA6nUrocNArHYO6pe1oHZZE6jphTQjAjOixWC6jonUNQz9+TuGL16AmBkDxxTfbY+9tRv3N7t/RPSlnH1KyfZWT1X8GPy/4Lq6uvDx3j3QFZVc4kIc4vfMQfZyCoakQJetdjTPggpxiDXOxofb38HGp55xFbmstGqaBkmSkMvlMDExUXAaDhc/rSYSCSiKUnhnZRgGsiwjm81icHAQoihidHQUmUymuAwNA/19fYXf9fX16OzsJAKWBednHVXS5g5cUDX/AWxcrYnxTduFAAAAAElFTkSuQmCC",
            details: {
                Name: "Butters",
                HR: [{
                    R: "Butters joins the school vampire gang - and becomes The Ungroundable"
                }, {
                    R: "Butters goes to Bennigans to have fried mozarella sticks in his favorite booth"
                }, {
                    R: "Butters astonishes the other children with the brilliance of his dancing"
                }, {
                    R: "Butters makes a surprising success out of being a pimp in Butters Bottom Bitch"
                }, {
                    R: "Butters farts in Cartman's face when Cartman's blasphemy ruins their career as a Christian rock band"
                }, {
                    R: "Butters shows everyone video of Cartman dressing up like Britney Spears to get his revenge after Cartman tricks him by pretending to be the robot AWSOM-O"
                }, {
                    R: "Butters discovers he is not the ugliest boy in class - he won't be grounded: hurrah!"
                }, {
                    R: "Butters successfully conceals his secret identity as Professor Chaos."
                }],
                SR: [{
                    R: "Butters parents sell him to Paris Hilton, who keeps him in a bear costume and calls him Mr. Biggles"
                }, {
                    R: "Butters gets hit in the eye with a ninja throwing star when the boys are playing at being manga heroes"
                }, {
                    R: "Butters discovers that Raisin waitress Lexus does not really love him but just wants his money."
                }, {
                    R: "Butters is sent to Tolerance Camp for disapproving of what Mr. Slave does with Lemmiwinks"
                }, {
                    R: "Cartman pretends to be Butters and gets him into trouble with his parents, then brings a chair and popcorn so he can enjoy listening to the subsequent beating"
                }, {
                    R: "Butters is almost put down at the animal shelter when he is mistaken for an injured dog"
                }, {
                    R: "Butters risks dancing again - and once again, people die"
                }, {
                    R: "Butters is fired as the boys' fourth friend for being 'lame'"
                }, {
                    R: "Butters mother tries to drown him when she discovers his father has been hanging out in Turkish Bath houses"
                }],
                HS: [{
                    S: "Boy oh Boy!"
                }, {
                    S: "Oh Golly Gosh!"
                }, {
                    S: "Everybody knows it's Butters - that's me!"
                }, {
                    S: "I'd rather be a crying little p***y than a f**gy goth kid!"
                }, {
                    S: "This beats waking up to the sound of my own screams!"
                }, {
                    S: "Oh Boy - baby back ribs at Bennigans!"
                }],
                SS: [{
                    S: "Lemmiwinks - NO!"
                }, {
                    S: "You're breaking my b***ls.  My b***ls.  You're breaking my b***ls."
                }, {
                    S: "Can't I just have some Spaghettios?"
                }, {
                    S: "I'm not gay, I'm bi-curious"
                }, {
                    S: "I'm a dork"
                }, {
                    S: "You have to be careful with scissors"
                }, {
                    S: "Son of a biscuit!"
                }, {
                    S: "I need to learn to behave myself"
                }, {
                    S: "Oh Eric!"
                }, {
                    S: "Oh hamburgers!"
                }, {
                    S: "There'a gonna be heck to pay, heck I tell ya!"
                }]
            },
            name: "Butters",
            id: 5707702298738688
        }
    ];
    dispatch(loadPlayers(p));
}
